import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  constructor() {}


  scrollToElementById(id: string) {
    const element = this.__getElementById(id);
    this.scrollToElement(element);
  }

  private __getElementById(id: string): HTMLElement {
    const element = document.getElementById(id)!;
    return element;
  }

  scrollToElement(element: HTMLElement) {
    element.scrollIntoView({ behavior: "smooth" });
  }

  focusElementById(id: string) {
    const element = this.__getElementById(id);
    this.focusElement(element);
  }

  focusElement(element: HTMLElement) {
    element.focus();
  }

  selectElementById(id: string) {
    const element = this.__getElementById(id);
    if (!(element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)) return;
    this.selectElement(element);
  }

  selectElement(element: HTMLInputElement | HTMLTextAreaElement) {
    element.select();
  }
}
